import * as $ from 'jquery'
export const mobileProductFilterBtn = ()=>{
 const $btn =$('.mobile-product-filter-js');
 $btn.on('click',function(){
     $('#product_filter').toggleClass('hidden');
     $(this).find('.filter-icon').toggleClass('hidden');
     $(this).find('.close-icon').toggleClass('hidden');
 })
}